import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Hardware from '../views/Hardware.vue'
import SetupTelkomNewDevice from '../views/SetupTelkomNewDevice.vue'
import SetupTelkomOldDevice from '../views/SetupTelkomOldDevice.vue'
import SetupPureNewDevice from '../views/SetupPureNewDevice.vue'
import SetupPureDeviceType from '../views/SetupPureDeviceType.vue'
import SetupPureHuawei from '../views/SetupPureHuawei.vue'
import SetupPureGeneric from '../views/SetupPureGeneric.vue'
import SetupVodacomNewDevice from "@/views/SetupVodacomNewDevice.vue";
import SetupVodacomDeviceType from "@/views/SetupVodacomDeviceType.vue";
import SetupVodacomGeneric from "@/views/SetupVodacomGeneric.vue";
import SetupVodacomHuawei from "@/views/SetupVodacomHuawei.vue";
import SetupPureZTE from "@/views/SetupPureZTE.vue";
import SetupAfrihostNewDevice from "@/views/SetupAfrihostNewDevice.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/hardware',
        name: 'hardware',
        component: Hardware
    },
    {
        path: '/setup/telkom-lte/new-device',
        name: 'setup-telkom-new-device',
        component: SetupTelkomNewDevice
    },
    {
        path: '/setup/telkom-lte/old-device',
        name: 'setup-telkom-old-device',
        component: SetupTelkomOldDevice
    },
    {
        path: '/setup/pure-lte/new-device',
        name: 'setup-pure-new-device',
        component: SetupPureNewDevice
    },
    {
        path: '/setup/afrihost/new-device',
        name: 'setup-afrihost-new-device',
        component: SetupAfrihostNewDevice
    },
    {
        path: '/setup/pure-lte/device-type',
        name: 'setup-pure-device-type',
        component: SetupPureDeviceType
    },
    {
        path: '/setup/pure-lte/device/huawei',
        name: 'setup-pure-device-huawei',
        component: SetupPureHuawei
    },
    {
        path: '/setup/afrihost/device/zte',
        name: 'setup-afrihost-device-zte',
        component: SetupPureZTE
    },
    {
        path: '/setup/pure-lte/device/generic',
        name: 'setup-pure-device-generic',
        component: SetupPureGeneric
    },
    {
        path: '/setup/vodacom/new-device',
        name: 'setup-vodacom-new-device',
        component: SetupVodacomNewDevice
    },
    {
        path: '/setup/vodacom/device-type',
        name: 'setup-vodacom-device-type',
        component: SetupVodacomDeviceType
    },
    // {
    //     path: '/setup/vodacom/old-device',
    //     name: 'setup-vodacom-old-device',
    //     component: SetupVodacomOldDevice
    // },
    {
        path: '/setup/vodacom/device/huawei',
        name: 'setup-vodacom-device-huawei',
        component: SetupVodacomHuawei
    },
    {
        path: '/setup/vodacom/device/generic',
        name: 'setup-vodacom-device-generic',
        component: SetupVodacomGeneric
    },
];

const router = new VueRouter({
    routes
});

export default router
